import { Modal } from "antd";
import Styles from "../css/payWithQuickbucks.module.scss";
import DOMPurify from 'dompurify';
import Back from "../../../../assets/back-icon.svg";
import { useState } from "react";
import { useAppSelector } from "customHooks/useAppSelector";
const PayWithQuickbucksTermsAndCondition = (props: any) => {
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
  });

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    setCheckboxes({
      ...checkboxes,
      [name]: checked,
    });
  };

  const paymentData = useAppSelector(
    (state) => state?.payLaterVendor?.paymentInfo
  );

  const isButtonDisabled = !checkboxes.checkbox1;
  const sanitizedTerms = DOMPurify.sanitize(paymentData?.TandCUrl || '');
  const sanitizedHtmlTerms = DOMPurify.sanitize(paymentData?.Terms || '');

  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        centered
        width={500}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        // className="parent"
        className={Styles.customModal}
      >
        <div className={Styles.topHeader}>
          <div>
            <img
              onClick={props.returnBack}
              src={Back}
              className={Styles.backIcon}
              alt="back"
            />
          </div>
          {/* <div>
            <img
              onClick={props.handleCancel}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
          </div> */}
        </div>
        <div className={Styles.topText}>Terms and Condition</div>
        <div
          className={Styles.modalContentVerification}
          style={{ maxHeight: "60vh", overflow: "scroll" }}
        >
          {/* <div className={Styles.descThree}>
            These terms and conditions ("Terms") outline the agreement between
            you ("Borrower") and theQuickBucks governing the use of the loan
            services provided by the App. By using the App and applying for a
            loan, you acknowledge and agree to be bound by these Terms. Please
            read them carefully before proceeding.
          </div> */}

          {/* <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              1. Eligibility:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              {" "}
              a. To use the loan services provided by the App, the Borrower must
              be at least 18 years old.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              {" "}
              b. The Borrower must have a valid bank account and meet any other
              eligibility criteria set by the App.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              2. Loan Application:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. The App offers a loan application process through its platform.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The Borrower must provide accurate and complete information
              during the application process.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              c. The App reserves the right to verify the information provided
              by the Borrower using various means, including but not limited to
              credit checks and third-party data sources.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              3. Loan Approval and Disbursement:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. Loan approval and disbursement are subject to the App's review
              and assessment of the Borrower's application and eligibility.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The App may require additional documentation or information for
              verification purposes.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              c. The Borrower acknowledges that loan approval is not guaranteed
              and is subject to the App's sole discretion.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              4. Loan Repayment:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. The Borrower agrees to repay the loan amount, including any
              interest and fees, in accordance with the terms specified by the
              App.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The App may automatically deduct the loan repayment amount from
              the Borrower's designated bank account on the agreed-upon
              repayment dates.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              c. Failure to repay the loan as per the agreed terms may result in
              additional fees, penalties, and adverse effects on the Borrower's
              credit history.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              5. Interest Rates and Fees:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. The App will disclose the applicable interest rates, fees, and
              charges associated with the loan.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The Borrower agrees to pay the interest and fees as specified
              by the App.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              c. The App reserves the right to modify interest rates and fees,
              providing reasonable notice to the Borrower.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              6. Privacy and Security:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. The App will handle the Borrower's personal and financial
              information in accordance with applicable laws and regulations.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The Borrower acknowledges that the App may collect, store, and
              process their information for loan evaluation and servicing
              purposes.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              7. Modification and Termination:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. The App reserves the right to modify or terminate its loan
              services, including these Terms, at any time, with or without
              notice.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. The Borrower may terminate their use of the App's loan services
              by complying with the termination procedure specified by the App.
            </div>
          </div>

          <div className={Styles.top}>
            <div
              style={{ fontWeight: "bold", paddingTop: "1em" }}
              className={Styles.descThree}
            >
              8. Governing Law and Dispute Resolution:
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              a. These Terms shall be governed by and construed in accordance
              with the laws of [Jurisdiction].
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              b. Any disputes arising from or relating to these Terms shall be
              resolved through arbitration or mediation as per the App's dispute
              resolution policy.
            </div>
          </div> */}

          <div
            style={{ paddingTop: '1em' }}
            className={Styles.descThree}
            dangerouslySetInnerHTML={{ __html: sanitizedHtmlTerms }}
          />


          {/* <iframe
            src={sanitizedTerms}
            width="100%"
            height="600px"
            style={{ border: "none" }}
          ></iframe> */}



          <div className={Styles.top}>
            <div className={Styles.rowTerms}>
              <input
                type="checkbox"
                name="checkbox1"
                checked={checkboxes.checkbox1}
                onChange={handleCheckboxChange}
              />
              <div className={Styles.terms}>
                By using the loan services provided by the App, you confirm that
                you have read, understood, and agreed to these Terms. It is
                recommended to review these Terms periodically for any updates
                or changes made by the App.
              </div>
            </div>
          </div>
        </div>

        <div>
          <a
            target="_blank"
            href={sanitizedTerms}
            style={{
              color: "#228EF9",
              textAlign: "center",
              paddingLeft: "1.5em",
              display: "grid",
              justifyContent: "center",
            }}
            className={Styles.descThree}
          >
            Download Terms and Conditions
          </a>
          <div className={Styles.btnRow}>
            <button onClick={props.goToHistory} className={Styles.btnOutline}>
              DECLINE
            </button>
            <button
              onClick={props.openTerms}
              className={Styles.btn}
              disabled={isButtonDisabled}
              style={{
                background: isButtonDisabled ? "gray" : "",
              }}
            >
              ACCEPT TERMS
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksTermsAndCondition;
